export default __webpack_public_path__ + "static/media/avatar.361b326b.png";